<div *ngIf="!isCollapsed" class="eui-expand-content__body">
    <ng-content></ng-content>
</div>
<div class="eui-button__expand-trigger" [class.eui-button__expand-trigger--collapsed]="isCollapsed" (click)="onToggle()" aria-label="Expand / Collapse trigger">
    <button *ngIf="isCollapsed" class="eui-button eui-button--expand-toggle" aria-label="Expand">
        <span *ngIf="expandLabel" class="eui-label eui-u-color-grey-dark">{{expandLabel}}</span>
        <span class="eui-icon eui-icon-angle-down"></span>
    </button>
    <button *ngIf="!isCollapsed" class="eui-button eui-button--expand-toggle" aria-label="Collapse">
        <span *ngIf="collapseLabel" class="eui-label eui-u-color-grey-dark">{{collapseLabel}}</span>
        <span class="eui-icon eui-icon-angle-up"></span>
    </button>
</div>
